/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

import { useNavigate } from '@tanstack/react-router';

import { buildFullUrl, buildUserRoute } from '~/app/routes';

/**
 * Hook to get profile navigation functions with current user context
 * @returns Object with navigation functions that automatically handle current user context
 */
export const useProfileNavigation = () => {
  const navigate = useNavigate();

  return {
    /**
     * Opens a user profile in a new tab with automatic current user handling
     */
    openUserProfile: (userId: string, currentUserId?: string) => {
      if (userId.startsWith('bot_')) return;
      const path = userId === currentUserId ? '/account' : buildUserRoute(userId);
      window.open(buildFullUrl(path), '_blank', 'noopener');
    },

    /**
     * Navigates to a user profile in the current tab with automatic current user handling
     */
    navigateToUserProfile: (userId: string, currentUserId?: string) => {
      const to = userId === currentUserId ? '/account' : buildUserRoute(userId);
      navigate({ to });
    },
  };
};
